import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/index.css';

// Force scroll containment - override any inline styles added by third-party scripts (e.g. AdSense)
// Key insight: #root needs fixed height but CAN'T have overflow:hidden or children can't scroll
// Only body needs overflow:hidden to prevent page scroll
function enforceScrollContainment() {
  const root = document.getElementById('root');
  const body = document.body;

  // Check if AdSense has overridden our styles
  const rootHeight = root.style.getPropertyValue('height');
  const bodyHeight = body.style.getPropertyValue('height');

  // Fix #root height but DON'T set overflow:hidden (children need to scroll!)
  if (rootHeight === 'auto' || rootHeight === '') {
    root.style.setProperty('height', '100vh', 'important');
    // Note: Explicitly remove overflow:hidden from root if it exists
    if (root.style.getPropertyValue('overflow') === 'hidden') {
      root.style.removeProperty('overflow');
    }
  }

  // Fix body - needs both height AND overflow:hidden to prevent page scroll
  if (bodyHeight === 'auto' || bodyHeight === '') {
    body.style.setProperty('height', '100vh', 'important');
    body.style.setProperty('overflow', 'hidden', 'important');
  }
}

// Enforce after a short delay to let React mount
setTimeout(enforceScrollContainment, 100);

// Re-enforce periodically in case AdSense or other scripts modify it
setInterval(enforceScrollContainment, 2000);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
